const SET_STATISTICS = (state, data) => {
  state.created = new Date().toString()
  state.calledCountries = data.calledCountries
  state.paymentCount = data.paymentCount
  state.firstPaymentDate = data.firstPaymentDate
  state.lastPaymentDate = data.lastPaymentDate
  state.callCount = data.callCount
  state.firstCallDate = data.firstCallDate
  state.lastCallDate = data.lastCallDate
}

export default {
  SET_STATISTICS
}



// WEBPACK FOOTER //
// ./src/store/modules/user/statistics/mutations.js